import { render, staticRenderFns } from "./QuotesList.vue?vue&type=template&id=4590ccdd&"
import script from "./QuotesList.vue?vue&type=script&lang=ts&"
export * from "./QuotesList.vue?vue&type=script&lang=ts&"
import style0 from "./QuotesList.vue?vue&type=style&index=0&id=4590ccdd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports